// extracted by mini-css-extract-plugin
export default {"container":"BidList_container__8gs-K"};